import React from 'react';
import InputError from '../InputError';
import './Select.scss';

export default function Select ({ options = [], label, error, ...rest }) {
    return (
        <div className={"form-input" + (rest.required ? ' required ' : '')}>
            {label ? <label>{label}</label> : null}
            <select {...rest}>
                {options.map((o, k) => <option key={k} value={o.value}>{o.label || o.value}</option>)}
            </select>
            {error ? <InputError error={error}/> : null}
        </div>
    );
};